import * as $ from 'jquery';
import 'selectize';
import 'datepicker';
import * as moment from 'moment';
import { bookingFormCommon } from './c005-bookingform-common';
import { covidWaiverPage } from './c109-covidwaiver-form';

export class motEnrollmentForm {
    initFormTextInputs(): any {
        let _self: any = this;
        let $motEnrollmentForm: any = $('#mot-enrollment');
        let inputElArr = $motEnrollmentForm.find('input[type="text"], input[type="email"]');
        for (var i = 0, len = inputElArr.length; i < len; i++) {
            if (!inputElArr[i].classList.contains('datepicker')) { // exclude datepicker input fields
                $(inputElArr[i]).attr('autocomplete', 'new-password');
                $(inputElArr[i])
                    .on('focus', function (e: any) {
                        let $this: any = $(this);
                        $this.addClass('input-focused').removeClass('has-error');
                        $this.parent().addClass('input-focused');
                        $this.parent().find('label').addClass('input-filled').removeClass('has-error');
                    })
                    .on('blur', function (e: any) {
                        let $this: any = $(this);
                        if ($this.val() == '') {
                            $this.removeClass('input-focused');
                            $this.parent().removeClass('input-focused');
                            $this.parent().find('label').removeClass('input-filled');
                        }
                        else {
                            $this.addClass('input-focused');
                            $this.parent().find('label').addClass('input-filled');
                        }
                    });
            }
        }
    }
    initSelectizeInputs(): any {
        let _self = this;
        var countryCodeInput = $('#select-country-code');
        var getcountryCodeOptions = $.Deferred();
        let countryCodeurl: string = $('[data-country-code-url]').attr('data-country-code-url');

        if (countryCodeurl) {
            $.get(countryCodeurl)
                .done((data: any) => {
                    var listItems = "<option value=''> </option>";
                    if (typeof data === 'string') {
                        data = JSON.parse(data);
                    }

                    for (let i = 0; i < data.Phonecodes.length; i++) {
                        if (data.Phonecodes[i].Code == "+60") {
                            listItems += "<option value='" + data.Phonecodes[i].Code + "'>" + data.Phonecodes[i].Name + " ( " + data.Phonecodes[i].Code + " )" + "</option>";
                        }
                    }
                    getcountryCodeOptions.resolve(listItems);
                })
                .fail((error: any) => {
                    getcountryCodeOptions.reject(error);
                });
            $.when(getcountryCodeOptions).done(function (countryCodeOptions: any) {
                countryCodeInput.html(countryCodeOptions);
                _self.initCountryCodeSelectizeinputs(countryCodeInput);
            });
        }
    }
    initCountryCodeSelectizeinputs(inputSelect: any) {
        let _self = this;
        let $this: any = $(inputSelect);
        let $thisLabel: any = $this.parent().find('label');
        $this.selectize({
            valueField: 'value',
            labelField: 'text',
            searchField: ['text'],
            selectOnTab: true,
            onInitialize: () => {
                $this[0].selectize.$control_input.attr('name', $this[0].selectize.$input[0].id.split('--')[1]);
                $this[0].selectize.setValue("+60");
                $this[0].selectize.lock();
            },
            onFocus: () => {
                $thisLabel.addClass('input-filled');
                $($this[0].selectize.$control[0]).addClass('select-filled');

            },
            onChange: (value: any) => {
                $thisLabel.addClass('input-filled');
                $($this[0].selectize.$control[0]).addClass('select-filled');
            },
            onBlur: () => {
                let $activeOptionChange: any = $this[0].selectize.getValue();

                if ($activeOptionChange == null || !$activeOptionChange.length) {
                    $thisLabel.removeClass('input-filled');
                    $($this[0].selectize.$control[0]).removeClass('select-filled');
                } else {
                    $thisLabel.addClass('input-filled');
                    $($this[0].selectize.$control[0]).addClass('select-filled');
                }
            }

        });
    }
    initDatepickerInputs(): any {
        let _self = this;
        let $fields = $('#mot-dob');
        // let minDate = new Date();
        let $label: any = $fields.parent().find('label');
        $fields.attr('readonly', 'readonly');
        $fields.datepicker({
            showButtonPanel: true,
            closeText: '<i class="fa fa-times" aria-hidden="true"></i>',
            dateFormat: 'd M yy',
            numberOfMonths: 1,
            changeMonth: true,
            changeYear: true,
            yearRange: "-70:+0",
            // minDate: minDate,
            onSelect: function (dateText: string, instance: any) {
                $fields.parent().addClass('input-focused');
                $fields.addClass('input-focused').removeClass('has-error');
                $label.addClass('input-filled').removeClass('has-error');
            },
            beforeShow: function (elm: any, instance: any) {
                instance.dpDiv.addClass("mot-dob-datepicker");
                if ($(elm).attr('readonly')) { return false; }
            }
        }
        );
    }
    submitForEmailValidation(): any {
        $('.mot-enrollment-continue').click((evt: any) => {
            evt.preventDefault();
            let _self: any = this;
            let $motEnrollmentForm: any = $('#mot-enrollment');
            let $emailID: any = $motEnrollmentForm.find('.mot--email');
            let $emailIDItem: any = $emailID.parent().parent().find('.form-item');
            let $motNRIC: any = $motEnrollmentForm.find('.mot--malaysia--nric');
            let $motNRICItem: any = $motNRIC.parent().parent().find('.form-item');
            let $firstName: any = $motEnrollmentForm.find('.mot--firstname');
            let $lastName: any = $motEnrollmentForm.find('.mot--lastname');
            let $dobMot: any = $motEnrollmentForm.find('#mot-dob');
            let $label: any = $dobMot.parent().find('label');
            let $motEnrichID: any = $motEnrollmentForm.find('#motEnrichID');
            let $motUserType: any = $motEnrollmentForm.find('#motUserType');
            let $motEnrichStatus: any = $motEnrollmentForm.find('#motEnrichStatus');
            let $motMheStatus: any = $motEnrollmentForm.find('#motMheStatus');
            let $loginErrorDiv: any = $('.login-error--validation');
            let $loginValidator: any = $('.login-validator');
            let $formfillContinueDiv: any = $('.mot-coninue-section');
            let formData: Array<any> = [];
            let bcommon: any = new bookingFormCommon();
            _self.$loginError = [];
            $loginErrorDiv.show();
            let $validationSuccess: any = true;
            if ($emailID.val() == "") {
                let $emailIDEmptyValidate: any = "This value is required";
                _self.$loginError.push('<strong>' + $emailID.parent().find('label').text().trim() + ':</strong> ' + $emailIDEmptyValidate);
                $emailIDItem.addClass('has-error');
                $validationSuccess = false;
            }
            else if (!(this.validateEmail($emailID.val()))) {
                let $emailIDInvalidValidate: any = "This email address is not valid";
                _self.$loginError.push('<strong>' + $emailID.parent().find('label').text().trim() + ':</strong> ' + $emailIDInvalidValidate);
                $emailIDItem.addClass('has-error');
                $validationSuccess = false;
            }
            else {
                $emailIDItem.removeClass('has-error');
            }
            if ($motNRIC.val() == "") {
                let $nricEmptyValidate: any = "This value is required";
                _self.$loginError.push('<strong>' + $motNRIC.parent().find('label').text().trim() + ':</strong> ' + $nricEmptyValidate);
                $motNRICItem.addClass('has-error');
                $validationSuccess = false;
            }
            else if ($motNRIC.val().length < 12) {
                let $nricInvalidValidate: any = "This NRIC is not valid";
                _self.$loginError.push('<strong>' + $motNRIC.parent().find('label').text().trim() + ':</strong> ' + $nricInvalidValidate);
                $motNRICItem.addClass('has-error');
                $validationSuccess = false;
            }
            else if (!(this.isValidNRICDate())) {
                let $nricInvalidValidate: any = "This NRIC is not valid";
                _self.$loginError.push('<strong>' + $motNRIC.parent().find('label').text().trim() + ':</strong> ' + $nricInvalidValidate);
                $motNRICItem.addClass('has-error');
                $validationSuccess = false;
            }
            else {
                $motNRICItem.removeClass('has-error');
            }
            var $validationContainer = $loginValidator.html('<ul class="validation--error-list"></ul>').find('.validation--error-list');
            var $validationMessagelist = $validationContainer;

            for (var i = 0, len = _self.$loginError.length; i < len; i++) {
                $validationMessagelist.append('<li data-id="' + i + '">' + _self.$loginError[i] + '</li>');
            }
            if ($validationSuccess) {
                $loginErrorDiv.hide();
                $('.mot-enrollment-continue').hide();
                formData = $motEnrollmentForm.find('input:not([id*="-selectized"]), select, textarea').serializeArray();
                let jsonformData = new FormData();
                if (formData.length > 0) {
                    formData.forEach(function (item: any) {
                        jsonformData.append(item.name, item.value);
                    });
                }
                let emailValidationurl: string = $('[data-email-validation-url]').attr('data-email-validation-url');
                if (emailValidationurl) {
                    bcommon.preloader();
                    $.ajax({
                        type: 'POST',
                        url: emailValidationurl,
                        data: jsonformData,
                        success: function (data: any) {
                            if (typeof data === 'string') {
                                data = JSON.parse(data);
                            }
                            _self.extractdobNric();
                            if (data.hasOwnProperty('isDataAvailable')) {
                                if (data.isDataAvailable) {
                                    if (data.hasOwnProperty('data')) {
                                        if (data.data.hasOwnProperty('firstName')) {
                                            if (data.data.firstName != null && data.data.firstName != '') {
                                                $firstName.val(data.data.firstName);
                                                $firstName.attr({
                                                    'readonly': 'readonly'
                                                });
                                                $firstName.prev().css({
                                                    'background-color': '#eee'
                                                });
                                                $firstName.addClass('input-focused');
                                                $firstName.parent().find('label').addClass('input-filled');
                                            }
                                        }
                                        if (data.data.hasOwnProperty('lastName')) {
                                            if (data.data.lastName != null && data.data.lastName != '') {
                                                $lastName.val(data.data.lastName);
                                                $lastName.attr({
                                                    'readonly': 'readonly'
                                                });
                                                $lastName.prev().css({
                                                    'background-color': '#eee'
                                                });
                                                $lastName.addClass('input-focused');
                                                $lastName.parent().find('label').addClass('input-filled');
                                            }
                                        }
                                        if (data.data.hasOwnProperty('dateOfBirth')) {
                                            if (data.data.dateOfBirth != null && data.data.dateOfBirth != '') {
                                                let now = moment(),
                                                    year = now.year();
                                                let parsedDate = moment($motNRIC.val().slice(0, 6), 'YYMMDD');
                                                if (parsedDate.year() > year) {
                                                    parsedDate.subtract(100, "year");
                                                }
                                                let isSameDate = moment(data.data.dateOfBirth, 'YYYY-MM-DD').isSame(parsedDate);
                                                if (!isSameDate) {
                                                    _self.$loginError.push("The NRIC is not match with your account, please check your NRIC number.");
                                                    var $validationMessagelist = $validationContainer;
                                                    for (var i = 0, len = _self.$loginError.length; i < len; i++) {
                                                        $validationMessagelist.append('<li data-id="' + i + '">' + _self.$loginError[i] + '</li>');
                                                    }
                                                    $loginErrorDiv.show();
                                                    $('.mot-enrollment-continue').show();
                                                    $formfillContinueDiv.addClass('hide');
                                                    bcommon.preloaderClose();
                                                    return;
                                                }

                                            }
                                        }
                                    }
                                }
                            }
                            if (data.hasOwnProperty('userType')) {
                                $motUserType.val(data.userType);
                            }
                            if (data.hasOwnProperty('enrichStatus')) {
                                $motEnrichStatus.val(data.enrichStatus);
                            }
                            if (data.hasOwnProperty('mheStatus')) {
                                $motMheStatus.val(data.mheStatus);
                            }
                            if (data.hasOwnProperty('enrichId')) {
                                if (data.enrichId != null && data.enrichId != '') {
                                    $motEnrichID.val(data.enrichId);
                                }
                                else {
                                    $motEnrichID.val("NA");
                                }
                            }
                            $formfillContinueDiv.removeClass('hide');
                            let toDisableInputs: any = $motEnrollmentForm.find('#mot--email, #mot--malaysia--nric');
                            toDisableInputs.each((i: number, el: any) => {
                                $(el).attr({
                                    'readonly': 'readonly'
                                });
                                $(el).prev().css({
                                    'background-color': '#eee'
                                });
                            });
                            bcommon.preloaderClose();
                        },
                        error: function (error: any) {
                            let isBlockedUser: boolean = false;
                            var $validationMessagelist;
                            if (typeof error.responseJSON === 'string') {
                                error.responseJSON = JSON.parse(error.responseJSON);
                            }
                            if (error.responseJSON.hasOwnProperty('code')) {
                                if (error.responseJSON.code != null && error.responseJSON.code != '') {
                                    if (error.responseJSON.code.toUpperCase().startsWith("MOT")) {
                                        if (error.responseJSON.hasOwnProperty('details')) {
                                            _self.$loginError.push(error.responseJSON.details);
                                            $validationMessagelist = $validationContainer;
                                            for (var i = 0, len = _self.$loginError.length; i < len; i++) {
                                                $validationMessagelist.append('<li data-id="' + i + '">' + _self.$loginError[i] + '</li>');
                                            }
                                            isBlockedUser = true;
                                        }
                                    }
                                }
                            }

                            if (!isBlockedUser) {
                                _self.$loginError.push("Sorry, we are unable to process your request at this time. Please try again later.");
                                $validationMessagelist = $validationContainer;
                                for (var i = 0, len = _self.$loginError.length; i < len; i++) {
                                    $validationMessagelist.append('<li data-id="' + i + '">' + _self.$loginError[i] + '</li>');
                                }
                            }
                            $loginErrorDiv.show();
                            $('.mot-enrollment-continue').show();
                            bcommon.preloaderClose();
                        },
                        cache: false,
                        contentType: false,
                        processData: false,
                    });
                }
            }
        });
    }
    extractdobNric(): void {
        let $motEnrollmentForm: any = $('#mot-enrollment');
        let $motNRIC: any = $motEnrollmentForm.find('.mot--malaysia--nric');
        let $dobMot: any = $motEnrollmentForm.find('#mot-dob');
        let $label: any = $dobMot.parent().find('label');
        let now = moment(),
            year = now.year();
        let parsedDate = moment($motNRIC.val().slice(0, 6), 'YYMMDD');
        if (parsedDate.year() > year) {
            parsedDate.subtract(100, "year");
        }
        $dobMot.datepicker('setDate', parsedDate.toDate()).trigger('blur', 'input');
        $dobMot.attr({
            'readonly': 'readonly'
        });
        $dobMot.parent().parent().css({
            'pointer-events': 'none'
        });
        $dobMot.css({
            'background-color': '#eee'
        });
        $dobMot.parent().addClass('input-focused');
        $dobMot.addClass('input-focused').removeClass('has-error');
        $label.addClass('input-filled').removeClass('has-error');
    }
    isValidNRICDate() {
        let $motEnrollmentForm: any = $('#mot-enrollment');
        let $motNRIC: any = $motEnrollmentForm.find('.mot--malaysia--nric');
        let extractedDob: any = moment($motNRIC.val().slice(0, 6), 'YYMMDD');
        return extractedDob.isValid();
    }
    validateEmail($emailID: string) {
        let emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
        return emailReg.test($emailID);
    }
    validateNRICandMobile(): any {
        $("#mot--malaysia--nric, #mot--mobile-number").keypress(function (e: any) {
            if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
                return false;
            }
            else {
                return true;
            }
        });

    }
    submitForVoucher(): any {
        $('.mot-enrollment-submit').click((evt: any) => {
            evt.preventDefault();
            let _self: any = this;
            let $motEnrollmentForm: any = $('#mot-enrollment');
            let $firstName: any = $motEnrollmentForm.find('.mot--firstname');
            let $firstNameItem: any = $firstName.parent().parent().find('.form-item');
            let $lastName: any = $motEnrollmentForm.find('.mot--lastname');
            let $lastNameItem: any = $lastName.parent().parent().find('.form-item');
            let $dobMot: any = $motEnrollmentForm.find('#mot-dob');
            let $dobMotDateItem: any = $dobMot.parent().parent().find('.form-item');
            let $countryCodeMot: any = $motEnrollmentForm.find('.select-country-code');
            let $countryCodeMotItem: any = $countryCodeMot.parent().parent().find('.form-item');
            let $mobilePhoneMot: any = $motEnrollmentForm.find('.mot--mobile-number');
            let $mobilePhoneMotItem: any = $mobilePhoneMot.parent().parent().find('.form-item');
            let $agreementMotVal: any = $motEnrollmentForm.find(".enrollment-agreement input[type='checkbox']:checked");
            let $agreementMot: any = $motEnrollmentForm.find(".enrollment-agreement");
            let $loginErrorDiv: any = $('.login-error--validation');
            let $loginValidator: any = $('.login-validator');
            let formData: Array<any> = [];
            let bcommon: any = new bookingFormCommon();
            _self.$loginError = [];
            let $validationSuccess: any = true;
            if ($firstName.val() == "") {
                let $firstNameEmptyValidate: any = "This value is required";
                _self.$loginError.push('<strong>' + $firstName.parent().find('label').text().trim() + ':</strong> ' + $firstNameEmptyValidate);
                $firstNameItem.addClass('has-error');
                $validationSuccess = false;
            }
            else {
                $firstNameItem.removeClass('has-error');
            }
            if ($lastName.val() == "") {
                let $lastNameEmptyValidate: any = "This value is required";
                _self.$loginError.push('<strong>' + $lastName.parent().find('label').text().trim() + ':</strong> ' + $lastNameEmptyValidate);
                $lastNameItem.addClass('has-error');
                $validationSuccess = false;
            }
            else {
                $lastNameItem.removeClass('has-error');
            }
            if ($dobMot.length > 0) {
                if ($dobMot.val() == '') {
                    let $sdobMotValidate: any = "This value is required";
                    _self.$loginError.push('<strong>' + $dobMot.parent().find('label').text().trim() + ':</strong> ' + $sdobMotValidate);
                    $dobMotDateItem.addClass('has-error');
                    $validationSuccess = false;
                } else {
                    $dobMotDateItem.removeClass('has-error');
                }
            }
            if ($countryCodeMot.length > 0) {
                if ($countryCodeMot.val() == '') {
                    let $countryCodeValidate: any = "This value is required";
                    _self.$loginError.push('<strong>' + $countryCodeMot.parent().find('label').text().trim() + ':</strong> ' + $countryCodeValidate);
                    $countryCodeMotItem.addClass('has-error');
                    $validationSuccess = false;
                } else {
                    $countryCodeMotItem.removeClass('has-error');
                }
            }
            if ($mobilePhoneMot.val() == "") {
                let $mobilePhoneEmptyValidate: any = "This value is required";
                _self.$loginError.push('<strong>' + $mobilePhoneMot.parent().find('label').text().trim() + ':</strong> ' + $mobilePhoneEmptyValidate);
                $mobilePhoneMotItem.addClass('has-error');
                $validationSuccess = false;
            }
            else {
                $mobilePhoneMotItem.removeClass('has-error');
            }
            if ($agreementMotVal.val() == '' || $agreementMotVal.val() == undefined) {
                let $enrollmentAgrementValidate: any = "This value is required";
                _self.$loginError.push('<strong>' + 'Consent' + ':</strong> ' + $enrollmentAgrementValidate);
                $agreementMot.addClass('has-error');
                $agreementMot.parent().find('.booking-form--title').addClass('has-error');
                $validationSuccess = false;
            } else {
                $agreementMot.removeClass('has-error');
                $agreementMot.parent().find('.booking-form--title').removeClass('has-error');
            }
            var $validationContainer = $loginValidator.html('<ul class="validation--error-list"></ul>').find('.validation--error-list');
            var $validationMessagelist = $validationContainer;

            for (var i = 0, len = _self.$loginError.length; i < len; i++) {
                $validationMessagelist.append('<li data-id="' + i + '">' + _self.$loginError[i] + '</li>');
            }
            $loginErrorDiv.show();
            if ($validationSuccess) {
                $loginErrorDiv.hide();
                formData = $motEnrollmentForm.find('input:not([id*="-selectized"]), select, textarea').serializeArray();
                let countryCode: string = '';
                if ($countryCodeMot.length > 0) {
                    countryCode = $countryCodeMot.val();
                }
                formData.push({
                    "name": "countryCode",
                    "value": countryCode
                });
                let dobMot: any;
                if ($dobMot.length > 0) {
                    dobMot = moment(new Date($dobMot.val())).format('DD/MM/YYYY');
                }
                formData.push({
                    "name": "dob",
                    "value": dobMot
                });
                let jsonformData = new FormData();
                if (formData.length > 0) {
                    formData.forEach(function (item: any) {
                        jsonformData.append(item.name, item.value);
                    });
                }

                let submitVoucherurl: string = $('[data-submit-voucher-url]').attr('data-submit-voucher-url');
                if (submitVoucherurl) {
                    bcommon.preloader();
                    $.ajax({
                        type: 'POST',
                        url: submitVoucherurl,
                        data: jsonformData,
                        success: function (data: any) {
                            if (typeof data === 'string') {
                                data = JSON.parse(data);
                            }
                            if (data.hasOwnProperty('message')) {
                                if (data.message.toUpperCase() == "OK") {
                                    $('.student-sucess-content').removeClass('hide');
                                    $('.mot-enrollment-component').addClass('hide');
                                    bcommon.preloaderClose();
                                }
                                else {
                                    _self.$loginError.push("Sorry, we are unable to process your request at this time. Please try again later.");
                                    var $validationMessagelist = $validationContainer;
                                    for (var i = 0, len = _self.$loginError.length; i < len; i++) {
                                        $validationMessagelist.append('<li data-id="' + i + '">' + _self.$loginError[i] + '</li>');
                                    }
                                    $loginErrorDiv.show();
                                    bcommon.preloaderClose();
                                }
                            }
                            else {
                                _self.$loginError.push("Sorry, we are unable to process your request at this time. Please try again later.");
                                var $validationMessagelist = $validationContainer;
                                for (var i = 0, len = _self.$loginError.length; i < len; i++) {
                                    $validationMessagelist.append('<li data-id="' + i + '">' + _self.$loginError[i] + '</li>');
                                }
                                $loginErrorDiv.show();
                                bcommon.preloaderClose();
                            }

                        },
                        error: function (error: any) {
                            let isAPIError: boolean = false;
                            if (typeof error.responseJSON === 'string') {
                                error.responseJSON = JSON.parse(error.responseJSON);
                            }
                            if (error.responseJSON.hasOwnProperty('status')) {
                                if (error.responseJSON.status == "409") {
                                    if (error.responseJSON.hasOwnProperty('message')) {
                                        _self.$loginError.push(error.responseJSON.message);
                                        isAPIError = true;
                                    }
                                }
                            }
                            if (!isAPIError) {
                                _self.$loginError.push("Sorry, we are unable to process your request at this time. Please try again later.");
                            }
                            var $validationMessagelist = $validationContainer;
                            for (var i = 0, len = _self.$loginError.length; i < len; i++) {
                                $validationMessagelist.append('<li data-id="' + i + '">' + _self.$loginError[i] + '</li>');
                            }
                            $loginErrorDiv.show();
                            bcommon.preloaderClose();

                        },
                        cache: false,
                        contentType: false,
                        processData: false,
                    });
                }
            }
            $(window).scrollTop(0);
        });
    }
}
let scope: Element = document.querySelector('.mot-enrollment-component');
if (scope) {
    try {
        let enrollmentform = new motEnrollmentForm();
        enrollmentform.initFormTextInputs();
        enrollmentform.initSelectizeInputs();
        enrollmentform.initDatepickerInputs();
        enrollmentform.validateNRICandMobile();
        enrollmentform.submitForEmailValidation();
        enrollmentform.submitForVoucher();
    }
    catch (e) { console.error(e); }
}